import { useGetByEngagementId } from './useGetByEngagementId'
import { useGetByResolutionId } from './useGetByResolutionId'
import { useGetGroundTruth } from './useGetGroundTruth'

export const resolution = {
  getGroundTruth: useGetGroundTruth,
  getByEngagementId: useGetByEngagementId,
  getByResolutionId: useGetByResolutionId,
}
